import React from "react";
import { useSite } from "../lib/SiteContext";
import { mediaUrl } from "../lib/api";

const AboutSection = () => {
  const { content } = useSite();
  const a = content?.about || {};
  return (
    <section className="section-padding bg-primary text-primary-foreground" data-testid="about-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={mediaUrl(a.image_url)} alt="On board the boat" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-7 lg:pl-8 order-1 lg:order-2">
            <div className="overline mb-4 text-sand">{a.overline}</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mb-8 text-balance">
              {a.title}
            </h2>
            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-xl mb-12">
              {a.body}
            </p>
            <div className="grid grid-cols-3 gap-6 max-w-xl">
              {(a.stats || []).map((s, i) => (
                <div key={i} className="border-l border-white/20 pl-4">
                  <div className="font-serif text-3xl md:text-4xl text-sand">{s.value}</div>
                  <div className="text-xs uppercase tracking-[0.2em] text-white/60 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
